class AutomaticDiscountPrices {
  api_endpoint = 'https://boncharge.io/=/api/getautomaticdiscount';

  context = {};
  numberFormat = {}
  discount = {};

  productListPriceWrapperSelector = '.card-wrapper:not(:has(a[href*="gift-card"],a[href*="membership"])) .card__content .card__information .card-information .price .price__container';
  productListPriceWrapperCollectionSelector = '.card-wrapper:not(:has(a[href*="gift-card"],a[href*="membership"])) .card__content .card__information .card-information .price[data-shipping-product-restrictions] .price__container';

  constructor(context, discount = null) {
    this.context = context;
    this.numberFormat = this.extractMoneyDetails(this.context.currency.number);

    if (!$) {
      console.log('AutomaticDiscountPrices: jQuery is missing');
      return false;
    }
    const _this = this;

    if (discount === null) {
      this.getAutomaticDiscount().then(data => {
        if (!data || !data.discount) {
          // nothing to do
        } else {
          _this.init(data.discount);
        }
      });
    } else {
      _this.init(discount);
    }
  }

  init(discount) {
    this.discount = discount;
    if (!this.discount) {
      return;
    }

    /* will be deleted */
    if (this.discount.hasOwnProperty('markets_only') && this.discount.markets_only.length > 0 && !this.discount.markets_only.includes(this.context.market)) {
      return;
    }
    /* will be deleted */

    const markets = this.discount?.markets ?? [];
    const marketsCondition = this.discount?.marketsCondition ?? 'include';
    if (markets.length && (marketsCondition === "include" && !markets.includes(this.context.market))) {
      return;
    }
    if (markets.length && (marketsCondition === "exclude" && markets.includes(this.context.market))) {
      return;
    }

    if (this.context.template === 'product') {
      this.initProduct();
    }
    this.initProductList();

    if (!this.discount.items.length) { // homepage collections
      this.addTag($('.collection-list-multicolumn').find('.media'));
    }

    /* TEMP */
    if (this.discount.title === 'CHARGE15') {
      //$('.main-video-banner').addClass('hidden');
      console.log('CHARGE15');
    }
    /* TEMP */
  }

  initProduct() {
    const $priceWrapper = $('div[id^="price-template--"][id$="__main"]');

    const _this = this;

    if (!this.discount.items.length || (this.discount.items.length > 0 && $.inArray(this.context.handle, this.discount.items) > -1)) {
      if (!this.context.handle.includes("gift-card") && !this.context.handle.includes("membership")) {
        this.processProduct($priceWrapper);
        const priceChangeObserver = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
              _this.processProduct($(mutation.target));
            }
          });
        });
        priceChangeObserver.observe($priceWrapper[0], { childList: true });
      }
    }
    this.processProductList($('product-recommendations'));

    const recommendedObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          recommendedObserver.disconnect();
          _this.processProductList($(mutation.target));
        }
      });
    });
    recommendedObserver.observe($('section[id^="shopify-section-template--"][id$="__related-products"] product-recommendations')[0], { childList: true, subtree: true });

    // const accessoriesObserver = new MutationObserver(function(mutations) {
    //   mutations.forEach(function(mutation) {
    //     if (mutation.type === 'childList') {
    //       accessoriesObserver.disconnect();
    //       _this.processProductAccessories();
    //     }
    //   });
    // });
    // accessoriesObserver.observe($('#product-accessories')[0], { childList: true, subtree: true });
    _this.processProductAccessories();
  }

  processProduct($priceWrapper) {
    const $priceContainer = $priceWrapper.children('.price');
    const $salePrice = $priceContainer.find('.price__sale');
    const discountElements = this.getDiscountElements($priceContainer);

    $salePrice.html(discountElements);
    $('#bch-sticky-add-to-cart > div > span').addClass('bch-has-discounted-price').html(discountElements);

    $priceContainer.addClass('bch-has-discounted-price');

    this.addTag($('media-gallery'), true);
  }

  processProductAccessories() {
    const $priceContainers = $('#product-accessories ul li');
    const _this = this;
    $priceContainers.each(function() {
      const $priceContainer = $(this).find('.price .price__container');
      const handle = $(this).find('.product-accessories--product-title a').attr('data-product-handle');
      if (!_this.discount.items.length || (_this.discount.items.length > 0 && $.inArray(handle, _this.discount.items) > -1)) {
        const $salePrice = $priceContainer.find('.price__sale');
        const discountElements = _this.getDiscountElements($priceContainer);
        $salePrice.html(discountElements/*.replace(' ' + _this.context.currency.isoCode, '')*/);
        $priceContainer.addClass('bch-has-discounted-price');
      }
    });
  }

  initProductList() {

    this.processProductList($('.product-list-multicolumn')); //HOMEPAGE

    this.processProductList($('.collection')); //HOMEPAGE

    const $priceWrapper = $('#ProductGridContainer');
    if (!$priceWrapper.length) {
      return;
    }
    this.processProductList($priceWrapper);

    const _this = this;
    const productListObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && $('#gf-grid').find(_this.productListPriceWrapperCollectionSelector).length) {
          productListObserver.disconnect();
          _this.processProductList($(mutation.target), _this.productListPriceWrapperCollectionSelector);
        }
      });
    });
    productListObserver.observe($priceWrapper[0], { childList: true, subtree: true });
  }

  processProductList($priceWrapper, childSelector) {
    const priceContainerSelector = childSelector ?? this.productListPriceWrapperSelector;
    const _this = this;

    // setTimeout(function(){
    $priceWrapper.find(priceContainerSelector).each(function() {
      const $priceContainer = $(this);
      const handle = _this.getProductHandleFromUrl(
        $priceContainer.parents('.card__information').find('.full-unstyled-link').attr('href')
      );
      if (!_this.discount.items.length || (_this.discount.items.length > 0 && $.inArray(handle, _this.discount.items) > -1)) {
        const $salePrice = $priceContainer.find('.price__sale');
        const discountElements = _this.getDiscountElements($priceContainer);

        $salePrice.html(discountElements);
        $priceContainer.addClass('bch-has-discounted-price');

        _this.addTag($priceContainer.parents('.card').find('.card__media'));
      }
    });
    // }, 1000);
  }

  getProductHandleFromUrl(pathname) {
    const pathParts = pathname.split('/');
    if (pathParts.length >= 3 && pathParts[1] === 'products') {

      const index = pathParts[2].indexOf("?");
      return index === -1 ? pathParts[2] : pathParts[2].slice(0, index);

      // return pathParts[2];
    }
    return null;
  }

  addTag($tagContainer, isPdpTag = false) {
    let discountText = (this.discount.value * 100) + '% OFF';
    if (isPdpTag && (this.context.handle.endsWith('-kit') || this.context.handle.endsWith('-bundle'))) {
      discountText = 'Extra ' + discountText;
    }
    $tagContainer.append('<div class="bch-has-discounted-price-tag">' + discountText + '</div>');
  }

  getDiscountElements($priceContainer) {
    const $regularPrice = $priceContainer.find('.price__regular .price-item.price-item--regular');
    const currency_format_parts = this.context.currency.format.split(/{{.*?}}/);
    let regularPrice = $regularPrice.text();
    currency_format_parts.forEach(format => {
      if (format) regularPrice = regularPrice.replace(format, '');
    });
    regularPrice = parseFloat(regularPrice
      .replace(this.numberFormat.thousandSeparator, '')
      .replace(this.numberFormat.decimalSeparator, '.')
      .replace(/\s/g, '')
      .trim()
    );
    const discountedPrice = (regularPrice * (1 - this.discount.value)).toFixed(2);
    const discountedPriceMoney = this.formatMoney(discountedPrice);
    return `
      <span class="visually-hidden visually-hidden--inline">Regular price</span>
      <span><s class="price-item price-item--regular" aria-label="Regular price">${$regularPrice.text().trim()}</s></span>
      <span class="visually-hidden visually-hidden--inline">Sale price</span>
      <span class="price-item price-item--sale price-item--last">${discountedPriceMoney}</span>
    `;
  }

  async getAutomaticDiscount() {
    return await fetch(this.api_endpoint, { method: "GET" }).then((response) => response.json()).catch((e) => {
      console.error(e);
      return false;
    });
  }

  formatMoney(cents, format) {
    let money_format = this.context.currency.format;
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    let value = '',
      placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = (format || money_format);

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) { return 0; }
      number = (number/100.0).toFixed(precision);
      let parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
    }
    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, this.numberFormat.thousandSeparator, this.numberFormat.decimalSeparator);
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, this.numberFormat.thousandSeparator, this.numberFormat.decimalSeparator);
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", this.numberFormat.decimalSeparator);
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  extractMoneyDetails(moneyString) {
    let thousandSeparator = null;
    let decimalSeparator = null;
    const cleanedStringForSeparators = moneyString.replace(/[^0-9.,]/g, '');
    const potentialSeparators = (cleanedStringForSeparators.match(/[.,]/g) || []);

    if (potentialSeparators.length === 0) {
      return { thousandSeparator: null, decimalSeparator: null };
    }
    const matchDecimal = cleanedStringForSeparators.match(/([.,])(\d{1,2})$/);
    if (matchDecimal) {
      decimalSeparator = matchDecimal[1];
      const otherSeparatorCandidates = potentialSeparators.filter(sep => sep !== decimalSeparator);
      if (otherSeparatorCandidates.length > 0) {
        thousandSeparator = otherSeparatorCandidates[0];
      }
    } else {
      if (potentialSeparators.length > 0) {
        if (potentialSeparators.every(sep => sep === potentialSeparators[0])) {
          thousandSeparator = potentialSeparators[0];
        }
      }
    }
    return { thousandSeparator, decimalSeparator };
  }
}

